export default __webpack_public_path__ + "media/images/icons_fc/chart-0a4418aafed47444051b1b54e366f958.png";